import React, { Component } from 'react';
import { isEmpty, getGuestRoomIconList } from '../../../Common/Common';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Icon_Carousel from '../../../Part_Sample/Icon_Carousel';

export default class Edit_Guest_Room extends Component {
	constructor(props) {
		super(props);
		// Set default guest_room_setting in case of first time open
		this.guest_room_settings = {
			locations: [],
			rooms: {}
		};
		// Default current location detail
		let room_detail = {
			icon: '',
		}
		let selected_icon = 'single.png';
		// If setting is not empty, set the current location details
		if (!isEmpty(this.props.param.guest_room_settings)) {
			this.guest_room_settings = JSON.parse(JSON.stringify(this.props.param.guest_room_settings));
			if (!isEmpty(this.props.param.guest_room_settings.rooms)) {
				if (!isEmpty(this.guest_room_settings.rooms[this.props.param.selected_room])) {
					room_detail = this.guest_room_settings.rooms[this.props.param.selected_room];
					selected_icon = room_detail.icon;
				}
			}
		}

		let icon_list = getGuestRoomIconList();
		for (let i in icon_list) {
			if (icon_list[i].key == selected_icon) {
				icon_list[i].is_selected = true;
				break;
			}
		}

		this.state = {
			room_detail: room_detail,
			icon_list: icon_list,
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		let param = JSON.parse(JSON.stringify(this.props.param));
		delete param.selected_room;
		this.props.content_handler('Rooms', param);
	}

	handleSelectIcon = (key) => {
		let icon_list = this.state.icon_list;
		for (let i in icon_list) {
			if (icon_list[i].key == key) {
				icon_list[i].is_selected = true;
			} else {
				icon_list[i].is_selected = false;
			}
		}

		this.setState({ icon_list: icon_list })
	}

	handleRegister = () => {
		let selected_icon = '';
		for (let i in this.state.icon_list) {
			if (this.state.icon_list[i].is_selected) {
				selected_icon = this.state.icon_list[i].key;
				break;
			}
		}

		this.guest_room_settings.rooms[this.props.param.selected_room] = this.state.room_detail;
		this.guest_room_settings.rooms[this.props.param.selected_room].icon = selected_icon;
		window.app.showLoading();
		this.props.receiver.saveJSONFile({ name: 'guest_room_settings.json', data: this.guest_room_settings });
	}

	rcvSaveJSONFile = (data) => {
		window.app.hideLoading();
		if (data.result == 'OK') {
			window.app.content_area.current.switch_content.current.handleHideBottomMenu();
			let param = JSON.parse(JSON.stringify(this.props.param));
			delete param.selected_room;
			param.guest_room_settings = this.guest_room_settings;
			this.props.content_handler('Rooms', param);
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('edit_guest_room')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ overflow: 'auto', height: this.props.height - 120 }}>
						<div style={{ width: this.props.width - 20, marginLeft: 10, marginTop: 10, maxHeight: 50 }}>
							<span className='header' style={{ textAlign: 'left' }}>{this.props.param.selected_room}</span>
						</div>
						<div style={{ width: this.props.width - 20, marginLeft: 10, marginTop: 10, maxHeight: 50 }}>
							<span className='footnote' style={{ textAlign: 'left' }}>{this.props.receiver.getString('edit_guest_room_expl')}</span>
						</div>
						<div style={{ marginTop: 20 }}>
							<Icon_Carousel id={'room_icons'} width={this.props.width} icon_list={this.state.icon_list} handleSelectIcon={this.handleSelectIcon} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}